/* eslint-disable @typescript-eslint/no-explicit-any */
import { baseApi } from "./baseApi";
import {
  UseLoanPaginated,
  UseLoanCategory,
  TaxSystemsPaginated,
  TaxSystem,
  CatalogPersonType,
  FileCatalogResponse,
  CatalogFile,
  DocumentConfig,
  DocumentConfigResponse,
  BankResponse,
  Bank,
  GetCivilStatusResponse,
  Address,
  AddressResponse,
  DependenciasData,
  GetDependenciasResponse,
  CargoPublicoData,
  GetCargoPublicoResponse,
  GetPepsTypeDataResponse,
  PepsTypeData,
  RelationshipData,
  GetRelationshipResponse,
  PaymentMethod,
  GetPaymentMethodResponse,
  GetMatrimonialRegimesResponse,
  MatrimonialRegimesData,
  CivilStatus,
  ReferenceType,
  ReferenceTypeResponse,
  ColonyResponse,
  StateStructure,
  FinancedServicesResponse,
  FinancedServicesStructure,
  GuaranteeTypeResponse,
  GuaranteeConfigResponse,
  GuaranteeConfigStruture,
  BusinessSectorStructure,
  BusinessSectorResponse,
  ResponseLoanUseCategoryConfig,
  UseLoanCategoryConfig,
  VehicleStrutureCatalog,
  PropertyTypeCatalogResponse,
  PropertyTypeStrutureCatalog,
  GetTabsConfigResponse,
  TabsConfigResponseData,
  GuaranteeType,
  PriceVehicleResponse,
  CarVersionPrice,
  MotorbikeCatalogItem,
  MotorbikeCatalogResponse,
  PlatformCatalogResponse,
  PlatformCatalogItem,
} from "../types";
import { ThemeApiResponse, ThemeApiStructure } from "@interfaces/theme";

const catalogosApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTaxSystems: build.query<TaxSystem, string>({
      query: (code) => ({
        url: `catalogos/tax_systems`,
        params: { code: code },
      }),
      transformResponse: (response: { data: TaxSystemsPaginated }) => {
        return response.data.data[0];
      },
    }),
    getLoanUse: build.query<Array<UseLoanCategory>, void>({
      query: () => "catalogos/loan_use_categories",
      transformResponse: (response: { data: UseLoanPaginated }) => {
        return response.data.data.sort((a, b) => {
          if (a.order > b.order) return 1;

          if (a.order < b.order) return -1;

          return 0;
        });
      },
    }),
    getLoanUseCategoriesConfig: build.query<Array<UseLoanCategoryConfig>, { taxCode?: string }>({
      query: ({ taxCode }) => {
        let url = `catalogos/loan_use_categories_config`;
        if (taxCode) {
          url += `?taxcode=${taxCode}`;
        }
        return url;
      },
      transformResponse: (response: ResponseLoanUseCategoryConfig) => {
        return response.data.data;
      },
    }),
    getPersonType: build.query<Array<CatalogPersonType>, void>({
      query: () => "catalogos/person_type?=user_for_rol:true&size=100",
      transformResponse: (response: { data: any }) => {
        const data = response.data.data.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            tax_systems_id: item.tax_systems_id,
            use_for_rol: item.use_for_rol,
            code: item.code,
            tax_system_type: item.tax_system_type,
          };
        });
        return data;
      },
    }),
    getStates: build.query<Array<StateStructure>, void>({
      query: () => "catalogos/state",
      transformResponse: (response: { data: any }) => {
        const result = response.data.data.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
          };
        });
        return result;
      },
    }),
    getFilesCatalog: build.query<Array<CatalogFile>, void>({
      query: () => ({
        url: "catalogos/file_category",
        params: {
          size: 1000,
        },
      }),
      transformResponse: (response: FileCatalogResponse) => {
        return response.data.data;
      },
    }),
    getDocsConfig: build.query<Array<DocumentConfig>, { taxCode: string; personCode: string | undefined }>({
      query: (params) => ({
        url: `catalogos/document_config`,
        params: {
          taxcode: params.taxCode,
          personcode: params.personCode || "",
        },
      }),
      transformResponse: (response: DocumentConfigResponse) => {
        return response.data.data;
      },
    }),
    getBanksByCode: build.query<Bank | undefined, string>({
      query: (codeBank) => ({
        url: "catalogos/banks",
        params: {
          q: `code:${codeBank}`,
        },
      }),
      transformResponse: (response: BankResponse) => {
        return response.data.data.length > 0 ? response.data.data[0] : undefined;
      },
    }),
    getCivilStatus: build.query<CivilStatus[], void>({
      query: () => `catalogos/civil_status`,
      transformResponse: (response: GetCivilStatusResponse) => {
        return response.data.data;
      },
    }),
    getAddressType: build.query<Address[], void>({
      query: () => "catalogos/address_type",
      transformResponse: (response: AddressResponse) => {
        return response.data.data;
      },
    }),
    getBusinessActivities: build.query<
      Array<{ id: string; name: string; description: string; business_sector_id: string }>,
      void
    >({
      query: () => "catalogos/business_activity",
      transformResponse: (response: { data: any }) => {
        return response.data.data.map((item: any) => ({
          id: item.id,
          name: item.name,
          description: item.description,
          business_sector_id: item.business_sector_id,
        }));
      },
    }),
    getDependecias: build.query<DependenciasData[], void>({
      query: () => "catalogos/dependencies",
      transformResponse: (response: GetDependenciasResponse) => {
        return response.data.data;
      },
    }),
    getCargoPublico: build.query<CargoPublicoData[], void>({
      query: () => "catalogos/public_office",
      transformResponse: (response: GetCargoPublicoResponse) => {
        return response.data.data;
      },
    }),
    getPepsType: build.query<PepsTypeData[], void>({
      query: () => "catalogos/pep_type",
      transformResponse: (response: GetPepsTypeDataResponse) => {
        return response.data.data;
      },
    }),
    getRelationship: build.query<RelationshipData[], void>({
      query: () => "catalogos/relationship",
      transformResponse: (response: GetRelationshipResponse) => {
        return response.data.data;
      },
    }),
    getPaymentMethod: build.query<PaymentMethod[], void>({
      query: () => "catalogos/payment_method",
      transformResponse: (response: GetPaymentMethodResponse) => {
        return response.data.data;
      },
    }),
    getMatrimonialRegimes: build.query<MatrimonialRegimesData[], void>({
      query: () => "catalogos/matrimonial_regimes",
      transformResponse: (response: GetMatrimonialRegimesResponse) => {
        return response.data.data;
      },
    }),
    getReferenceTypes: build.query<Array<ReferenceType>, void>({
      query: () => "catalogos/reference_type",
      transformResponse: (response: { data: ReferenceTypeResponse }) => {
        return response.data.data;
      },
    }),
    getColonyById: build.query<ColonyResponse, { colonyId: number }>({
      query: ({ colonyId }) => `/catalogos/colonia/${colonyId}`,
      transformResponse: (response: { data: ColonyResponse }) => {
        return response.data;
      },
    }),
    getFinancedServices: build.query<FinancedServicesStructure[], void>({
      query: () => "catalogos/financed_services",
      transformResponse: (response: FinancedServicesResponse) => {
        return response.data.data;
      },
    }),
    getGuaranteeType: build.query<GuaranteeType[], void>({
      query: () => "catalogos/guarantee_type",
      transformResponse: (response: GuaranteeTypeResponse) => {
        return response.data.data;
      },
    }),
    getGuaranteeConfig: build.query<GuaranteeConfigStruture[], { tax_code: string }>({
      query: ({ tax_code }) => `catalogos/guarantee_config?taxcode=${tax_code}`,
      transformResponse: (response: GuaranteeConfigResponse) => {
        return response.data.data;
      },
    }),
    getBusinessSector: build.query<BusinessSectorStructure[], void>({
      query: () => "catalogos/business_sector",
      transformResponse: (response: BusinessSectorResponse) => {
        return response.data.data;
      },
    }),
    getVehiclesByYear: build.query<VehicleStrutureCatalog[], { year: string }>({
      query: ({ year }) => `/cotizador/autos/marcas?year=${year}`,
      transformResponse: (response: any) => {
        return response.data;
      },
    }),
    getVehiclesByYearAndMake: build.query<VehicleStrutureCatalog[], { year: string; make: string }>({
      query: ({ year, make }) => `/cotizador/autos/modelos?year=${year}&make=${make}`,
      transformResponse: (response: any) => {
        return response.data;
      },
    }),
    getVehiclesByYearMakeAndModel: build.query<VehicleStrutureCatalog[], { year: string; make: string; model: string }>(
      {
        query: ({ year, make, model }) => `/cotizador/autos/versiones?year=${year}&make=${make}&model=${model}`,
        transformResponse: (response: any) => {
          return response.data;
        },
      },
    ),
    getVehiclesYears: build.query<string[], void>({
      query: () => `/cotizador/autos/annus`,
      transformResponse: (response: any) => {
        return response.data;
      },
    }),
    getPropertyType: build.query<PropertyTypeStrutureCatalog[], void>({
      query: () => `catalogos/property_type`,
      transformResponse: (response: PropertyTypeCatalogResponse) => {
        return response.data.data;
      },
    }),
    // getBusinessSector: build.query<BusinessSectorStrutureCatalog[], void>({
    //   query: () => `catalogos/business_sector`,
    //   transformResponse: (response: BusinessSectorCatalogResponse) => {
    //     return response.data.data;
    //   },
    // }),
    getTabsConfig: build.query<Array<TabsConfigResponseData>, { taxcode: string }>({
      query: ({ taxcode }) => `catalogos/tabs_bofu_config?taxcode=${taxcode}`,
      transformResponse: (response: GetTabsConfigResponse) => {
        return response.data.data;
      },
    }),
    getPriceVehiclesByVersion: build.query<CarVersionPrice, { version: string }>({
      query: ({ version }) => `/cotizador/autos/precios?version=${version}`,
      transformResponse: (response: PriceVehicleResponse) => {
        return response.data;
      },
    }),
    getMotorbikeCatalog: build.query<MotorbikeCatalogItem[], void>({
      query: () => "catalogos/motorbike",
      transformResponse: (response: MotorbikeCatalogResponse) => {
        return response.data.data;
      },
    }),
    getMotorbikeCatalogById: build.query<MotorbikeCatalogItem, string>({
      query: (id: string) => `/catalogos/motorbike?q=id:${id}`,
      transformResponse: (response: MotorbikeCatalogResponse) => {
        if (response.data.data.length < 1) {
          throw new Error("Motorbike catalog not found");
        }
        return response.data.data[0];
      },
    }),
    getPlatformCatalog: build.query<PlatformCatalogItem[], void>({
      query: () => "catalogos/platform",
      transformResponse: (response: PlatformCatalogResponse) => {
        const data = [...response.data.data].sort((a, b) => a.order - b.order);
        return data;
      },
    }),
    getThemeConfig: build.query<ThemeApiStructure, string>({
      query: (url) => ({
        url: `catalogos/company_configuration`,
        params: { url: url },
      }),
      transformResponse: (response: ThemeApiResponse) => {
        return response.data;
      },
    }),
  }),
});

export const {
  useLazyGetLoanUseQuery,
  useLazyGetLoanUseCategoriesConfigQuery,
  useLazyGetMatrimonialRegimesQuery,
  useLazyGetTaxSystemsQuery,
  useGetPersonTypeQuery, // todo: se podria cambiar por useLazyGetPersonTypeQuery
  useLazyGetPersonTypeQuery,
  useLazyGetStatesQuery,
  useGetFilesCatalogQuery, // todo: se podria cambiar por useLazyGetFilesCatalogQuery
  useLazyGetFilesCatalogQuery,
  useGetDocsConfigQuery, // todo: solo se usa en customUploadFile
  // useLazyGetDocsConfigQuery,
  useLazyGetBanksByCodeQuery,
  useLazyGetCivilStatusQuery,
  useGetAddressTypeQuery,
  useLazyGetAddressTypeQuery,
  useGetBusinessActivitiesQuery,
  useLazyGetDependeciasQuery,
  useLazyGetCargoPublicoQuery,
  useLazyGetPepsTypeQuery,
  useLazyGetRelationshipQuery,
  useGetPaymentMethodQuery, // todo: remover
  useLazyGetPaymentMethodQuery,
  useLazyGetReferenceTypesQuery,
  useLazyGetColonyByIdQuery,
  useLazyGetFinancedServicesQuery,
  useLazyGetGuaranteeTypeQuery,
  useLazyGetGuaranteeConfigQuery,
  useLazyGetVehiclesByYearQuery,
  useLazyGetVehiclesByYearAndMakeQuery,
  useLazyGetVehiclesByYearMakeAndModelQuery,
  useLazyGetVehiclesYearsQuery,
  useLazyGetBusinessSectorQuery,
  useLazyGetPropertyTypeQuery,
  useLazyGetTabsConfigQuery,
  useLazyGetPriceVehiclesByVersionQuery,
  useLazyGetMotorbikeCatalogQuery,
  useLazyGetMotorbikeCatalogByIdQuery,
  useLazyGetPlatformCatalogQuery,
  useLazyGetThemeConfigQuery,
} = catalogosApi;
